// アコーディオン
const accordion = () => {
    const triggerList = document.querySelectorAll('.js_accordion_trigger');

    // アコーディオンのトリガーが存在しない場合処理しない
    if (!triggerList.length) return;

    // アコーディオンを閉じる処理
    const closeAccordion = (trigger, target) => {
        trigger.classList.remove('is_active');
        target.classList.remove('is_active');
        target.style.height = '0';
    }

    // 他のアコーディオンを全て閉じる処理
    const closeAllAccordions = (currentTrigger) => {
        triggerList.forEach(trigger => {
            if (trigger !== currentTrigger) {
                const target = trigger.nextElementSibling;
                if (target && target.classList.contains('js_accordion_body') && trigger.classList.contains('is_active')) {
                    closeAccordion(trigger, target);
                }
            }
        });
    }

    // トリガーをクリックした時の処理
    const doWhenClicked = (e) => {
        const trigger = e.currentTarget; //トリガー（js_accordion_triggerクラスを持つ要素）
        const target = trigger.nextElementSibling; //アコーディオン中身

        // 次の要素がjs_accordion_bodyクラスを持っていない場合は処理しない
        if (!target.classList.contains('js_accordion_body')) return;

        const targetH = target.scrollHeight; //アコーディオン中身の高さ

        // 他のアコーディオンを全て閉じる
        closeAllAccordions(trigger);

        // アクティブクラスの付与/削除
        trigger.classList.toggle('is_active');
        target.classList.toggle('is_active');

        // アコーディオン中身の高さ制御
        if (target.classList.contains('is_active')) {
            target.style.height = `${targetH}px`;
        } else {
            target.style.height = '0';
        }
    }

    // トリガーにクリックイベントを設定
    triggerList.forEach(el => el.addEventListener('click', doWhenClicked));
}

export default accordion;